export default __webpack_public_path__ + "static/examp5-446e9d7ed0c04ea618c3a09c2ac687b7.gif";